import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable no-param-reassign */
import fetchAPI from 'utils/http/fetchAPI';
import { EXPERIMENTS_ERROR, EXPERIMENTS_SAVING, EXPERIMENTS_SAVED } from 'redux/actionTypes/experiments';
import endUserMessages from 'utils/endUserMessages';
import handleError from 'utils/http/handleError';
import httpStatusCodes from 'utils/http/httpStatusCodes';
var cloneExperiment = function cloneExperiment(originalId) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _newExperimentId, _message, _errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: EXPERIMENTS_SAVING
              });
              _context.prev = 1;
              _context.next = 4;
              return fetchAPI("/v2/experiments/".concat(originalId, "/clone"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  name: name
                })
              });
            case 4:
              _newExperimentId = _context.sent;
              dispatch({
                type: EXPERIMENTS_SAVED
              });
              return _context.abrupt("return", _newExperimentId);
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              _message = _context.t0.statusCode === httpStatusCodes.LOCKED ? endUserMessages.ERROR_CLONING_PIPELINE_LOCKED : endUserMessages.ERROR_CLONING_DEFAULT;
              _errorMessage = handleError(_context.t0, _message);
              dispatch({
                type: EXPERIMENTS_ERROR,
                payload: {
                  error: _errorMessage
                }
              });
              return _context.abrupt("return", originalId);
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default cloneExperiment;